function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnvelope(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-38"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-38"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M214.89,117.92c-9.26-9.23-17.81-18.9-31.3-23.07-28-8.66-61.23-3.39-83.81,16.34C68.5,138.52,61.15,184.38,66.19,221.65c5.72,42.23,23.31,83,52.65,114.57,32.08,34.54,77.07,57,124.64,68.18,25.69,6,52.66,9,79.16,5s52.57-15.26,70.85-34.26c25.4-26.37,32.93-64.2,30.35-99.1-1.81-24.46-8.57-49.45-25.69-67.37-31.92-33.4-84.51-35.9-126.06-54-17-7.41-33.23-16.52-47.5-27.91A120.34,120.34,0,0,1,214.89,117.92Z",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.89,117.92c-9.26-9.23-17.81-18.9-31.3-23.07-28-8.66-61.23-3.39-83.81,16.34C68.5,138.52,61.15,184.38,66.19,221.65c5.72,42.23,23.31,83,52.65,114.57,32.08,34.54,77.07,57,124.64,68.18,25.69,6,52.66,9,79.16,5s52.57-15.26,70.85-34.26c25.4-26.37,32.93-64.2,30.35-99.1-1.81-24.46-8.57-49.45-25.69-67.37-31.92-33.4-84.51-35.9-126.06-54-17-7.41-33.23-16.52-47.5-27.91A120.34,120.34,0,0,1,214.89,117.92Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-38"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-38"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M390.51,172.3l2.72-5.84s0-.17,0-.46h0s-.33-9.81-.76-12.85c-.32-2.28-1.3-2.6-1.78-2.61a8.61,8.61,0,0,0-2.24-1.36,59.11,59.11,0,0,0-6.88-3.59c-2.35-1.22-4.35-1.92-5.19-.59a12.38,12.38,0,0,0-.93,1.76c-.07.17-.13.33-.19.5l0,.1a10,10,0,0,0-.38,1.5l-3.4,2.47-1,.52,2,10.45,5.9,6.88s0,.28-.12.72a20.53,20.53,0,0,1-4.46,8.86,29,29,0,0,0-2.35,2.5c-.26.25-.51.5-.79.74-4.27,3.73-5.91,6.59-6.62,8.75l0,.14a92.66,92.66,0,0,0-9.44-7.85c-.72-.56-7.38-6.38-12.12-10.89l-3.63-5.94c1.17,2.15-.93-1.81-1.12-2.22-2.12-4.72-3-9.93-5.46-14.51-3.66-7-12.19-12.31-20.53-13.4l4-9-3.92-1.57a1.45,1.45,0,0,0,.38.22c.88.32,2.59.94,4.66,1.6,13.8,5.28,17.66,2,18,1.74a3.18,3.18,0,0,0,1.56-3l-1.2-17.41a1.56,1.56,0,0,1,.42-1.18l3-3.31a1.6,1.6,0,0,0,.12-2l-4.09-5.75a1.57,1.57,0,0,1-.29-1.09l.46-4.32a1.49,1.49,0,0,0-.17-.9l-5.61-10.83a7.64,7.64,0,0,0,2.77-2.39c3.07-5,3-8.09.85-9.26s-6.26,6-16.6,3.74C310.9,70.31,300,80.51,296,88.57l4.25-9.79c-4.29,5.66-6.68,7.39-5.79,10-.09.06-.25.16-.45.31-3.69,2.93-4,5.87-4,5.87-1,3.5.38,8.74,6.29,15.58l-10.47,14a6.51,6.51,0,0,0-2.64-1c-4.29-.7-10.55,1.52-12.45,2.25-1.08-.28-2.12-.53-3.11-.74a28,28,0,0,0-9-1.56,31.12,31.12,0,0,0-9.54.49,33.94,33.94,0,0,0-5.27,1.93,26.21,26.21,0,0,0-4.46,2.24,34,34,0,0,0-4.24,2.74,56.12,56.12,0,0,0-11,10.2L220.84,145q-1.8,1.89-3.57,3.8A164.69,164.69,0,0,1,200.2,164a81.59,81.59,0,0,1-18.54,8.35c-4.5,1.44-9.21,2.68-13.91,3.8-5,1.08-10.1,2-15.19,3-2.6.44-5.25,1-7.82,1.62-2.79.61-5.57,1.27-8.33,2a59.77,59.77,0,0,0-9.63,2.95c-.9.32-1.8.66-2.69,1,.62.13,1.23.28,1.83.46a31.37,31.37,0,0,1,9.48,6.13,24.4,24.4,0,0,1,5.49,13.27c-.08,4.3-1.51,9.21-2.61,14-1.54,5.13-2.79,9.59-.78,13.51a10.52,10.52,0,0,0,2,3.27,19.78,19.78,0,0,0,4.06,3.71c2.79,2.18,6,4.32,8.48,6.86a59.84,59.84,0,0,1,4.72,9,37.79,37.79,0,0,0,2.54,6.24c.44,1,.9,2,1.42,2.95a10.93,10.93,0,0,0,.94,1.58,32.67,32.67,0,0,0,12.41,11.28,32.16,32.16,0,0,0,15.08,4.9h0a52.52,52.52,0,0,0-.77,5.45A60,60,0,0,0,178,293.3c-6.35,2.65-14.16,6.46-19.13,10.88A49.39,49.39,0,0,0,149,316.4,74.47,74.47,0,0,0,141.81,333c-.76,2.29-1.45,4.56-2.12,6.76l-.06-.14c0,.26-.09.52-.13.78-.82,2.73-1.61,5.36-2.43,7.8-3.26,7.53-8.66,15-11.3,18.94h0c-1.38,1.77-2.82,3.5-4.3,5.21-3.2,3.53-7.25,7.67-10.36,11.32a29.06,29.06,0,0,0-2.74,3.44,16,16,0,0,0-1.71,2.84c-2.37,5.52,2.86,9.36,6.55,14.07,0,0,.06.1.1.15a23.62,23.62,0,0,1,2.22,7.82,27.94,27.94,0,0,0,.67,7.31,12.36,12.36,0,0,0,3.14,5,22,22,0,0,0,6.38,5,28.11,28.11,0,0,0,3.73,1.9c3.74,1.49,16.09,1.4,18.85-3.39a9.73,9.73,0,0,0,.46-.91,4.29,4.29,0,0,0,.59-1.92,5.64,5.64,0,0,0-1.86-5c-.08.1.34.36.26.47-4.38-6.54-16.13-14.12-16-20.77.19-12.65,7.85-21.39,16.59-29.58,8.5-8,18.89-9.34,26.79-17.76,5.1-5.43,10.68-11,14.14-22.34,20.59-6.28,25.71-23.22,25.71-23.22,2.12-.86,3.86-1.69,5.82-2.56,5.64,8.53,9.68,14.15,10.27,13.78l45.36-30.51c1,1.19,10,11.8,18.67,14.63l.25.09,9.11,4.57c-1.56,5.54-9.24,7.13-9.24,7.13l0,.09-.69.14c-1.62-.06-10.67,0-18.49,8.47-3.71,3.6-8.6,10.13-12.24,15.22-3,4.18-5.06,7.21-5.06,7.21a31.21,31.21,0,0,0-4,1.24c-8.43,3.05-9.16,6.66-8.68,8.74a6,6,0,0,0,.11,1A6.36,6.36,0,0,0,248,359a17.55,17.55,0,0,0,2.94,2.74,19.86,19.86,0,0,1,3.95,4.79,54,54,0,0,1,2.39,8.34c1.29,5.51,7.77,17.76,16.78,18.29a19.67,19.67,0,0,0,6.45-.48c1.48-.28,2.93-.78,3.08-2a1.87,1.87,0,0,0,.12-.31s-.06-.09-.15-.26a3.43,3.43,0,0,0-.28-.86,58.3,58.3,0,0,0-4.1-6.63,52.54,52.54,0,0,1-5.13-15.13c-.05-.34-.09-.67-.13-1-.18-1.53-.42-3.23-.53-4.94,0-.18,0-.36,0-.53a15.87,15.87,0,0,1,1.46-7.52c1.71-2.76,4.85-4.25,7.94-5,2.17-.52,4.87-1.25,7.87-2.14a75.32,75.32,0,0,0,10.86-3.55c12.08-4.34,24.61-10.23,26.85-16,3.55-9.13,10.53-19,10.53-19C335.41,285,318,259.56,318,259.56l46.9-31.74c.42-.26-1.26-3.56-4.27-8.76l.82,1.3v0h0c3.08,1.76,8.69,2.55,12,2.88l.73.07a10.14,10.14,0,0,0,1.56.06c3.58-3.16,6.77-9.14,8.91-15a77.48,77.48,0,0,0,5.63-21.7,48,48,0,0,0,.39-10.65C390.68,174.8,390.62,173.56,390.51,172.3Zm-95.38-59.7c.38-.62.74-1.19,1.06-1.72l0,0,.11-.26c1.07-1.76,1.7-2.91,1.7-2.91l-.4-.09.13-.3.27.39A25.28,25.28,0,0,1,295.13,112.6Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.23,184s3.7,12.27,19.41,8.84c0,0,3.23-8,1.52-20.18l2.87-6.18s-.85-9.67-.71-11.11.17-4.44-4.35-6.29-10.23-6.59-11.82-4.06-1.39,3.75-1.39,3.75l-4,2.94,1.5,10.6,5.91,6.89s-.78,6.26-3.93,9A26.49,26.49,0,0,0,369.23,184Z",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385,193.56s3.76-16.31,1.3-25.9c0,0,5.51-5.1,3.93-17.11,0,0,1.61-.45,2,2.59S393,166,393,166l-2.68,6.18s-.2,14.1-1.08,19.68C389.23,191.86,389,193.09,385,193.56Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.82,138.91l50.62,74s3,3.07,10.29,4.45c0,0,10.78-12,13.24-23.79l4-.8s-4.64,23.28-13,30.72c0,0-10.09-.51-14.59-3.1l-50.93-80.59Z",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.82,138.91l50.62,74s3,3.07,10.29,4.45c0,0,10.78-12,13.24-23.79l4-.8s-4.64,23.28-13,30.72c0,0-10.09-.51-14.59-3.1l-50.93-80.59Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.73,136.33A24.91,24.91,0,0,1,332,149.47c2.4,4.58,3.33,9.79,5.46,14.51,3.52,7.81,10.1,13.8,16.87,19.06,4.26,3.3,8.73,6.47,12,10.76a20.79,20.79,0,0,1,3.59,7.27",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.78,190.74c.72-2.16,2.35-5,6.62-8.74,7.16-6.25,7.73-12.82,7.73-12.82l-5.91-6.89-2-10.44,4.32-2.22s.25-3.78,2.4-4.94,12.3,4.88,14.53,6.6c1.44,1.12.58,6.58,1.54,14.71-1.55,3.51-2.68,6.18-2.68,6.18,2.59,30.86-14.42,51.3-14.42,51.3a48.32,48.32,0,0,1-14.6-3.1",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.64,153.2l3.12,2.8a9.33,9.33,0,0,0,1.45,1.14,5.45,5.45,0,0,0,2.67,1.1,6,6,0,0,0,2.38-.37c.69-.3,2.21-3,2.41-3.68",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.08,183.29s3.21,13.73,20.19,9.24",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.84,145.93a6.27,6.27,0,0,0-3.68,3.82,6.84,6.84,0,0,0-.12,5.55",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.58,148.24a7.6,7.6,0,0,0-4.8,4.32,7.86,7.86,0,0,0-.43,5.15",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.68,157.46a12.79,12.79,0,0,1,3,2.26c1.84,2.05,2.19,5,2.46,7.72",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.52,149.63s3.25-2,3.8-.92",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.81,361.31s-19.13-4.95-21.92-21.48a91.47,91.47,0,0,1-11.08,22.69c-7.47,10.75-22.28,23.08-22.34,27.39s.83,6.95,4.71,10.57,4.3,13.18,4.45,15.43a16.79,16.79,0,0,0,7.13,11.73c5.56,4,14.53,5.65,21.13,2.94s6.11-7.77,3.9-10.24-15.51-14.67-16-18.8.94-12.54,5.35-19.22S152.4,365.41,161.81,361.31Z",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.69,127.27s-4.09,6.69-5.32,12.52",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.56,82.22c1.44,4.11,2.59,8.64,1.17,12.75-.87,2.53-2.64,4.66-3.54,7.17-1,2.73-.87,5.73-.75,8.63.17,3.92.44,8.12,2.86,11.2,3.53,4.5,10.08,4.85,15.36,7.07,0,0-3.55,3.85-18.11-1.74l-5-1.81-2.65,12.12s-1.56-2.62-4-2.22-8.92,5.23-8.92,5.23-3.72-3.68-4.55-6.16-3.1-8.42-5.74-9.79c0,0,11-13.32,12.22-16.93,0,0-6.24-8.22.92-11.45s11.09,5,11.09,5L307.4,90.62,317,82.5Z",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.56,82.22c1.44,4.11,2.59,8.64,1.17,12.75-.87,2.53-2.64,4.66-3.54,7.17-1,2.73-.87,5.73-.75,8.63.17,3.92.44,8.12,2.86,11.2,3.53,4.5,10.08,4.85,15.36,7.07,0,0-3.55,3.85-18.11-1.74l-5-1.81-2.65,12.12s-1.56-2.62-4-2.22-8.92,5.23-8.92,5.23-3.72-3.68-4.55-6.16-3.1-8.42-5.74-9.79c0,0,11-13.32,12.22-16.93,0,0-6.24-8.22.92-11.45s11.09,5,11.09,5L307.4,90.62,317,82.5Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.59,78.81l5.88,11.36a1.52,1.52,0,0,1,.17.89l-.46,4.33a1.59,1.59,0,0,0,.28,1.08l4.1,5.76a1.58,1.58,0,0,1-.13,2l-3,3.3a1.6,1.6,0,0,0-.41,1.18l1.2,17.41a3.17,3.17,0,0,1-2,3.17,14.15,14.15,0,0,1-4.49.75c-5.23.18-15.13-3.34-17.73-4.3a1.57,1.57,0,0,1-.91-.86l-4.33-10.24",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.26,101.54s-3-6.72-5.57-6-5.64,3-5.57,6.06,4.77,8.38,6.77,8.85a9.35,9.35,0,0,0,4.41-.34",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.18,96.65c0,1-.41,1.8-.89,1.79s-.86-.82-.84-1.81.41-1.8.89-1.79S330.2,95.66,330.18,96.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.58,108.54a4.65,4.65,0,0,0,3.69,4.52",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.42,90.36s-4.47-3.89-7.08,3.27",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.06,107.57l.78.17s-6.09,11.07-12.22,16.93",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.28,109s-2.5,19.1,1,27.9",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.85,90.29s-4.12-8.08,1.66-15.69",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.44,88.9c-7.85-.43-10.19,9-10.19,9",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.48,67.69c-2.12-1.18-6.26,6-16.6,3.74-6.59-1.42-22.43,2.93-21.51,17.35,0,0-12.09,7,1.66,22.13l1.77-4.11s-5.73-6.14-.78-9.25c4.38-2.74,4.94-2.41,9.11,4.22,0,0,1.4,2.9,4.12,2.08s2.6-1.95,1.5-4.68c-.41-1-1.09-2.7-1.65-4.56,2.48-.71,8.44-3.27,8.36-11.49V83c5.27-1.46,11.35-3.18,13.17-6.1C334.7,72,334.6,68.86,332.48,67.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.18,88.4c-.76-4.49,2.33-8.94,6.32-11.12s8.71-2.54,13.26-2.62a39,39,0,0,0,8.65-.7,14.22,14.22,0,0,0,2.89-1",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.42,90.82a8.67,8.67,0,0,1,6.93-7c1.81-.3,3.69,0,5.49-.38s3.64-1.76,3.56-3.6",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.93,170.2l47.88-34.09a4.89,4.89,0,0,1,7.05,1.5s58.13,88.81,55.88,90.21L230.85,317.89c-2.29,1.44-55.68-86.24-55.68-86.24a4.91,4.91,0,0,1,1.31-6.6l25.36-18.37",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.93,278.4c2.38,5.79,7.59,9.86,12.75,13.4s10.64,7,14.07,12.22,4.13,12.88-.24,17.35a3.82,3.82,0,0,1-3.27,1.41c-2.84-.56-2.34-5.2-4.65-6.94-3.49,4.94-10.7,6.84-14.74,7.41l2.15-9.44s5.29-.59,9.25-6.25c0,0-.16-2.54-9.37-5.54s-18.77-14.75-18.77-14.75Z",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.93,278.4c2.38,5.79,7.59,9.86,12.75,13.4s10.64,7,14.07,12.22,4.13,12.88-.24,17.35a3.82,3.82,0,0,1-3.27,1.41c-2.84-.56-2.34-5.2-4.65-6.94-3.49,4.94-10.7,6.84-14.74,7.41l2.15-9.44s5.29-.59,9.25-6.25c0,0-.16-2.54-9.37-5.54s-18.77-14.75-18.77-14.75Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.09,341.45s-14.75-7.68-9.55-27.4c0,0-10.12-.91-18.74,8.46s-17.3,22.43-17.3,22.43-12.76,3.86-12.63,8.76,3.81,7.12,6.33,9.12,3.62,6.52,4.91,12,7.77,17.76,16.78,18.29,9.64-2.79,9.64-2.79-1.91-3.37-4.39-7.52-5.86-14-5.94-21.85,3.11-11.32,8.62-12.61S297.37,345.07,304.09,341.45Z",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.64,287.61c-1.55-1.56,9.1,11.22,20.31,15.15,11,3.87,11,9.36,11,9.36",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.84,259.56s17.37,25.42,20.87,48.23c0,0-7,9.88-10.54,19S295,345.46,282.6,348.47c-3.36.81-6.8,2.48-8.37,5.73-1.75,3.62-.93,8.42-.49,12.26a42.7,42.7,0,0,0,3.13,12.32c1.66,3.75,4.5,6.78,6.24,10.44,1.42,3-2.24,3.4-4.48,3.7C264.86,394.79,258,379.75,256.35,371s-9.55-10.82-10.41-15.09c-1.59-7.88,12.56-11,12.56-11-.27.57,10.51-15.84,17.3-22.43,2.62-2.56,5.46-5.06,9-6.42s7.59-1.5,11.35-2.45,7.6-3.2,8.37-6.76",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.73,314.17s-7.08,17.93,9.79,27.39",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.28,284.31a48.19,48.19,0,0,0,19.87,14.52",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.91,317.16a34.82,34.82,0,0,0-9.64,2,18.74,18.74,0,0,0-8,5.62",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.17,323.63a118,118,0,0,0-17.55,8.25A42.46,42.46,0,0,0,261.57,345a11.4,11.4,0,0,1-1.41,1.95c-1.33,1.33-3.29,1.73-5.05,2.4-3.88,1.48-8.58,7.63-8.5,7.24,0,0-5.76-7,11.89-11.69,0,0,9.06-13.23,15.14-19.92s9.51-9.78,20.59-10.91Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294,141.7l1.22-1.09a56.34,56.34,0,0,1-4.34-7.33c-1.32-3-2.75-8.87-7.86-9.7s-13,2.48-13,2.48-11.29-4.26-21.07-2c0,0-13.54,3.29-25,17.11s-20.48,24.17-42.45,31.21-48.71,9.42-56.87,14.43c0,0,15.22,5.17,16.16,17.68s-7.34,22.12-3.45,29.68,11.1,9.16,14.28,13.46,7.12,14.6,8.95,18.63S174.2,282.59,189,284c0,0,2.91-13.4,6.62-19l-20.42-33.37s-2.42-3.73,1.63-7,25-17.93,25-17.93-3.43-6.35-4.1-11.48a14.49,14.49,0,0,0-4.38-8.34s2.37-7.31,7.93-11.6,16.08-14.37,20.68-20.92,14.88-25.76,33.78-28.09a30.46,30.46,0,0,1,10.16,5.9C271.08,136.6,281.09,144.25,294,141.7Z",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189,284s-12.6,0-23.33-11.72-8-17.61-12.82-23.24-13.44-9.14-15.51-14.89,2.67-19.88,3.36-24.81-2.5-19.14-16.07-22.55c0,0,15.88-5.84,29.7-7.9s33.24-7.31,42.17-12.53,24.09-20.81,27-24.17,13.68-14.83,22-16.76c6.7-1.55,10.31.84,10.31.84s-16,3.4-24.52,14.08c-6.85,8.54-8.24,15.17-17.43,23.88s-17.29,12.84-20.51,21.84c0,0,3.35,4.88,3.85,7.93s4.7,12.7,4.7,12.7l-25.36,18.37s-4,2.25-1.18,7.23,20.37,33,20.37,33S188.68,279.08,189,284Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271,125.94s10.51-3.56,13.85-1.56,10.38,16.82,10.38,16.82l-1.89,1.57s-14.69-1.37-19.95-5.18-12-11.88-24.09-12.77C249.32,124.82,256.1,122,271,125.94Z",
    style: {
      fill: "#fff",
      opacity: 0.38
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.81,124.72c-13.23,3.83-17.31,10.39-24.37,17.45-5.18,5.18-9.91,10.81-15.28,15.79-22.39,20.74-55.82,17.72-84.27,28.8a20.42,20.42,0,0,1,16.61,16.79c1.58,9.2-6.35,22.66-2.74,31.27,2.36,5.63,9.14,7.81,13.37,12.22,5,5.17,6,12.89,9.41,19.18,5.68,10.36,16.63,15.87,28.43,17.76",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.15,189.52c-1.61,1.64-3.06,3.43-4.64,5.09-7.95,8.32-18.93,12.93-29.57,17.33",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.92,197c-5.94,7-14.23,10.35-22.28,14.79s-16.19,10.15-19.33,18.79",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.44,130.5c-10.22-11.76-30-5.09-30-5.09,7.56-1,13.29,0,24.47,9.39,8.73,7.33,19.18,7.68,23.22,7.45",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.8,126.14a92.56,92.56,0,0,1,10-2.29,10.25,10.25,0,0,1,2.76-.19,7.37,7.37,0,0,1,4.86,3.11,29.4,29.4,0,0,1,2.8,5.22,56,56,0,0,0,5.07,8.57",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.45,281.32s-11.75,9.54-15,25.29a8.8,8.8,0,0,1-2-8.63s-33,14.06-45.85,49.83l-2.77-8s4.44-25.18,20.4-36.38c16.14-11.34,27.91-14,27.91-14s2-17.43,7.52-23.66Z",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.45,281.36s-11.75,9.5-15,25.25a8.8,8.8,0,0,1-2-8.63s-33,14.06-45.85,49.83l-2.77-8s4.44-25.18,20.4-36.38c16.14-11.34,27.91-14,27.91-14s2-17.2,7.52-23.43Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.62,304.09c-2,.88-3.73,1.72-5.86,2.58,0,0-5.12,16.94-25.71,23.23-3.46,11.32-9,16.91-14.14,22.34-7.9,8.41-18.29,9.8-26.79,17.75-8.75,8.19-16.4,16.93-16.59,29.58-.16,10.08,26.95,22.32,14.25,29.78s-29.46-2.75-30-12.5-2.16-13.38-7-18.66c-5.36-5.89-1.3-11,3.41-15.95,9.7-10.25,18-19.47,24.07-32.35,4.74-13.23,7.77-32.77,22.35-45.71,9.54-8.47,29.57-14.77,29.57-14.77s.91-13,7.49-24.11",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.73,339c.35-1,3,19.89,22.71,21.84",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.92,298.73a40.84,40.84,0,0,0-18.87,17.56",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.71,295.72a42.8,42.8,0,0,0-6.71,2.11",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.69,422a16.93,16.93,0,0,0,17.64,7.07",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.8,346.87c-3.4,9.49-8.21,18-15.67,24.78-3.16,2.88-6.64,5.44-9.49,8.64s-5.09,7.21-5.09,11.49A24.93,24.93,0,0,0,114,399q1.74,5.61,3.46,11.2a28.35,28.35,0,0,0,3.13,7.51,18.59,18.59,0,0,0,5.83,5.4,19.49,19.49,0,0,0,10.79,3.18c3.8-.14,8.38-3.15,10.58-6.26,0,0,3.06,2.9.3,7.69s-15.1,4.88-18.84,3.39-11.72-6.44-13.25-11.84.69-10.56-3-15.27-8.91-8.56-6.54-14.08,15.44-17.32,19.11-22.81,12.64-17.69,13.86-27.53Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "288.36 212.29 362.38 222.9 364.22 227.57 288.56 214.38 288.36 212.29",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "288.36 212.29 362.38 222.9 364.22 227.57 288.56 214.38 288.36 212.29",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "249.95 242.13 226.62 312.49 230.79 317.59 250.9 244.11 249.95 242.13",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "249.95 242.13 226.62 312.49 230.79 317.59 250.9 244.11 249.95 242.13",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "306.39 135.72 282.33 252.15 175.17 231.65 174.69 229.85 279 246.8 306.39 135.72",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "306.39 135.72 282.33 252.15 175.17 231.65 174.69 229.85 279 246.8 306.39 135.72",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 299.27,
    cy: 169.39,
    r: 15.06,
    transform: "translate(-42.85 134.6) rotate(-23.7)",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 301.46,
    y1: 154.23,
    x2: 305.95,
    y2: 135.56,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 230.72,
    y1: 317.4,
    x2: 251.81,
    y2: 242.1,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 286.93,
    y1: 214.3,
    x2: 364.5,
    y2: 227.46,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 238.29,
    y1: 200.08,
    x2: 275.62,
    y2: 173.23,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 240.28,
    y1: 205.59,
    x2: 278.48,
    y2: 178.08,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.59,214.58c4.28.34,9.2-2.69,11.64-6.17s4.38-7.5,7.9-9.94a26.75,26.75,0,0,1,7.65-3.13,20.11,20.11,0,0,0,7.45-3.53c2.09-1.81,3.42-4.72,2.58-7.33",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.17,218.12c4.28.66,8.21-2.33,10.89-5.7s4.76-7.31,8.27-9.83a23.54,23.54,0,0,1,9.25-4.3c5.67-1,9.45-4.47,9.64-7.86",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 299.2,
    cy: 169.22,
    r: 15.02,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.93,170.2l47.88-34.09a4.89,4.89,0,0,1,7.05,1.5s58.13,88.81,55.88,90.21L230.85,317.89c-2.29,1.44-55.68-86.24-55.68-86.24a4.91,4.91,0,0,1,1.31-6.6l25.36-18.37",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 279.86,
    y1: 242.94,
    x2: 294.18,
    y2: 183.6,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 174.42,
    y1: 229.86,
    x2: 252.03,
    y2: 242.05,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.88,225.16s12.07,1.47,18-14.08c0,0,7,10.35,12.73,14.22,0,0,2.44-.64,7.81.65a61.81,61.81,0,0,0,12.83,1.17s-1.33,4.67-4.29,4.76a12.14,12.14,0,0,1-5.54-1.32l-.66,1.63,19.85,14.86a3.07,3.07,0,0,1-.55,4.33l-14-9.7-.66,1.64s8.38,11.18,8.62,12.94-.16,1.88-1.51,2-3.34-1.94-3.34-1.94l-7.49-10.77-1.3,1.19s5.36,11,4.67,13.33-3.75-.91-3.75-.91l-4.16-9.77s1.63,7.71-.81,8.75-2.62-2.06-3.27-9.42l-6.48-8.85S231.64,231.27,223.88,225.16Z",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "230.68 223.78 251.74 238.26 257.01 248.72 251.45 240.74 223.78 226.13 230.68 223.78",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.05,130.18c-9.17,5-10.46,6.53-15.25,10.73-6,5.26-11.53,12-12.13,19.92a7,7,0,0,0,.63,4c1.26,2.25,4.34,2.93,6.82,2.22s4.5-2.47,6.43-4.18c-.53.47-.84,2.07-1.29,2.74a10.58,10.58,0,0,1-2.11,2.32,17,17,0,0,1-6.24,3c-5.49,1.57-11.52,1.47-17.2,2.6-6,1.19-10.09,4.29-13.94,8.92-2.73,3.28,2,11.75,3.37,15.79,3.18,9.68,11.3,18.37,18.54,25.53l-6.8,1.38s-18.35-9.71-22-18.48-5.71-16.21-8.87-20.33c0,0,2.67-6.29,14.41-16.62s17.81-20.51,22.36-26.7c6.14-8.37,20.3-16.26,26-16.78C255.73,126.22,258.17,126.63,263.05,130.18Z",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.19,130.11c-9.18,5-10.6,6.6-15.39,10.8-6,5.26-11.53,12-12.13,19.92a7,7,0,0,0,.63,4c1.26,2.25,4.34,2.93,6.82,2.22s4.5-2.47,6.43-4.18c-.53.47-.84,2.07-1.29,2.74a10.58,10.58,0,0,1-2.11,2.32,17,17,0,0,1-6.24,3c-5.49,1.57-11.52,1.47-17.2,2.6-6,1.19-10.09,4.29-13.94,8.92-2.73,3.28,2,11.75,3.37,15.79,3.18,9.68,11.3,18.37,18.54,25.53l-6.8,1.38s-18.35-9.71-22-18.48-5.71-16.21-8.87-20.33c0,0,2.67-6.29,14.41-16.62s17.81-20.51,22.36-26.7c6.14-8.37,21-16.21,26.7-16.73A45.91,45.91,0,0,1,263.19,130.11Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.13,192.33c8.29-5.65,21.49-17.24,23.8-31.46",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.31,227.07a39.5,39.5,0,0,1-16.61-20.2c-4.29-11.64-8.81-18.39-20.24-22.74",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205,205.08a34.4,34.4,0,0,0,14.64,13",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.49,197.54a32.07,32.07,0,0,0,2.27,5.41",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.88,225.16s13.28.35,18.24-14.69",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.1,133.39a36.37,36.37,0,0,1,6.8-2",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.31,149.54a35,35,0,0,1,15.37-15",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.3,181.5a13.17,13.17,0,0,1,8.48,6.92",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.35,225.67c2.64-1.21,6-.23,7.58.28,2.16.67,10.68,1.87,12.29,1.17s-1.41,3.67-3.27,4.53-6.56-1.09-6.56-1.09l-.66,1.63S283.91,245.6,285,247.5s.35,3.74-.94,3.88-14-9.7-14-9.7l-.66,1.64s10,12.81,9,14.15-3.1.8-4.72-.9-8-11-8-11l-1.3,1.19s5.37,12,4.67,13.33-2.38.85-3.36-.4-4.94-11.1-4.94-11.1,1.05,8.28.43,9.19a1.74,1.74,0,0,1-2.8-.08c-.63-1-1.32-9-1.32-9l-6.48-8.85c-13.57-5.36-37.87-21.69-37.87-21.69-12.82-10.31-14-18.7-15.52-24.2a17.46,17.46,0,0,0-3.78-7.12c3.47-13.39,19.47-16.12,31.78-37.37s31.53-23.16,31.53-23.16",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speed-lines--inject-38"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speed-lines--inject-38"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 88.21,
    y1: 319.71,
    x2: 65.79,
    y2: 338.25,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 146.71,
    y1: 271.33,
    x2: 101.78,
    y2: 308.48,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 87.79,
    y1: 254.83,
    x2: 78.94,
    y2: 262.15,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 129.74,
    y1: 220.14,
    x2: 94.73,
    y2: 249.09,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 107.79,
    y1: 245.31,
    x2: 86.45,
    y2: 262.96,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 219.94,
    y1: 333.13,
    x2: 192.16,
    y2: 356.1,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 234.79,
    y1: 320.85,
    x2: 223.74,
    y2: 329.98,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 230.56,
    y1: 330.92,
    x2: 219.51,
    y2: 340.06,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 354.56,
    y1: 131.19,
    x2: 347.76,
    y2: 136.81,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 382.14,
    y1: 108.38,
    x2: 357.8,
    y2: 128.51,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Clouds--inject-38"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--clouds--inject-38"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M335.23,247.26h96.48s-1-4.58-5.07-6-7,0-7-4.82-1.21-7.24-5.79-8.2c0,0-2.89-10.37-12.06-11.34s-15.68.24-17.13,5.79-2.89,8.44-5.54,8.2-7-2.89-9.17,2.17-2.17,8-5.55,7-10.13-5.31-15.43,3.38C349,243.41,340.29,239.79,335.23,247.26Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.75,142.86H72.27s1-4.59,5.07-6,7,0,7-4.83,1.21-7.23,5.79-8.2c0,0,2.89-10.37,12.06-11.34s15.68.24,17.13,5.79,2.89,8.44,5.54,8.2,7-2.89,9.17,2.17,2.17,8,5.55,7S149.7,130.31,155,139C155,139,163.69,135.38,168.75,142.86Z",
    style: {
      fill: "#fff"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelope);
export default __webpack_public_path__ + "static/media/envelope.156b07b9d9b33b748e9067b85db84b0f.svg";
export { ForwardRef as ReactComponent };